
import ResponsiveDialog from "./responsive-dialog.vue";
export default {
  components: { ResponsiveDialog },
  props: {
    dialog: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleOfflineConfirmation() {
      this.$emit("switch-change");
    }
  }
};
